import { useMemo, useState } from "react";
import {
  TAB_TYPE,
  initialNotificationFilterTypes,
} from "@pages/Dashboard/Notification/helper";
import NotificationContext, { NotificationType } from "./notificationContext";

const NotificationProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const notificationString = localStorage.getItem("notification");

  let InitialNotificationState = {
    currentTab: TAB_TYPE.UNREAD,
    filterType: initialNotificationFilterTypes,
  };

  if (notificationString !== null) {
    const { currentTab, filterType } = JSON.parse(notificationString);

    InitialNotificationState = {
      currentTab: currentTab || "",
      filterType: filterType || "",
    };
  }

  const [notificationState, notificationSetState] = useState<NotificationType>(
    InitialNotificationState
  );

  const stateValue = useMemo(
    () => [{ notificationState, notificationSetState }],
    [notificationState, notificationSetState]
  );

  return (
    <NotificationContext.Provider value={stateValue}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
